//set zoom level at 100%; IE and Chrome & Safari
function toggleZoomScreen(n) {
document.body.style.zoom=n.toString()+"%";
}

function get_browser_info(){
  const ua = navigator.userAgent;
  const IEmatch = ua.match(/(msie|trident)/i);
  if(IEmatch != null && IEmatch[1]){
    return {name:'IE ',version:''};
  }
  const info = bowser.parse(window.navigator.userAgent);
  return info.browser;
 }

//hide or show elements passed to these functions
function hide(){
  for(var j=0; j<arguments.length; j++){
    temp=String(arguments[j]);
    if(document.getElementById(temp) != undefined){
        document.getElementById(temp).style.display="none";
    }
  }
}

function show(){
  for(var j=0; j<arguments.length; j++){
    temp=String(arguments[j]);
    if(document.getElementById(temp) != undefined){
        document.getElementById(temp).style.display="block";
    }
  }
}

//check if all elements of the array are equal
function allTheSame(array) {
    var first = array[0];
    return array.every(function(element) {
        return element === first;
    });
}

//check if all elements of the array are equal
function allTheSameAndNA(array) {
    if (allTheSame(array) && array[0]=="na")
      {return 1;}
    else{return 0;}
}

function allTheSame(array) {
    var first = array[0];
    return array.every(function(element) {
        return element === first;
    });
}

function resultsArrayNotEmpty(array){
   for(var i=1;i<array.length;i++){
       if(array[i] !== "") {
        return true;
      }
   }
   return false;
}

// find all indices of a certain element in array
function getAllIndexes(arr, val) {
    var indices = [], i = -1;
    while ((i = arr.indexOf(val, i+1)) != -1){
        indices.push(i);
    }
    return indices;
}

function transpose(a) {
    if(!Array.isArray(a) || a.length <= 1){
      return [];
    }
    return Object.keys(a[1]).map(
        function (c) { return a.map(function (r) { return r[c]; }); }
        );
    }

function removeNA(results){
    var newResults = [];
    for(var i in results){
        if(results[i][0] == "response"){
            newResults.push(results[i]);
            continue;
        }
        var isEmptyColumn = true;
        for(var j in results[i]){
            if(results[i][0] == "subjectGroup" && results[i][j] == "0"){
              results[i][j] = "";
            }
            results[i][j] = (results[i][j] === "na") ? "" : results[i][j];
            if(j > 0 && results[i][j] != ""){
                isEmptyColumn = false;
            }
        }
        if(!isEmptyColumn){
            newResults.push(results[i]);
        }
    }
    return newResults;
}

//randomise array (Fisher-Yates shuffle)
//https://www.frankmitchell.org/2015/01/fisher-yates/
function shuffle (array) {
  var i = 0
    , j = 0
    , temp = null

  for (i = array.length - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i + 1))
    temp = array[i]
    array[i] = array[j]
    array[j] = temp
  }
}

//calculate average array
function mean(arr) {
var sum = 0;
for(var i = 0; i < arr.length; i++){sum += parseInt(arr[i]);}
var avg = sum/arr.length;
return avg;
}

//calculate average array
function meanFloats(arr) {
  var sum = 0;
  for(var i = 0; i < arr.length; i++){sum += parseFloat(arr[i]);}
  var avg = sum/arr.length;
  return avg;
  }

function standardDeviation(arr) {
  var sd = 0, count = arr.length;
  var average = meanFloats(arr);

  for(var i = 0; i < count; i++){
    var currentDeviation = arr[i] - average;
    sd += Math.pow(currentDeviation, 2);
  }

  sd = Math.sqrt(sd/(count - 1));

  return sd;
}

function randomString(length, chars) {
    var result = '';
    for (var i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
    return result;
}

// return a random permutation of a range (similar to randperm in Matlab)
function randperm(maxValue){
    // first generate number sequence
    var permArray = new Array(maxValue);
    for(var i = 0; i < maxValue; i++){
        permArray[i] = i;
    }
    // draw out of the number seque	nce
    for (var i = (maxValue - 1); i >= 0; --i){
        // var randPos = Math.floor(i * Math.random());
        var randPos = Math.floor((i+1) * Math.random());
        var tmpStore = permArray[i];
        permArray[i] = permArray[randPos];
        permArray[randPos] = tmpStore;
    }
    return permArray;
}

// return a random permutation of a range (similar to randperm in Matlab)
function randpermAB(maxValue,flagsArray){
    // first generate number sequence
    var permArray = new Array(maxValue);
    for(var i = 0; i < maxValue; i++){
        permArray[i] = i;
    }
    // draw out of the number sequence between A and B
    for (var iFlag = 0; iFlag < flagsArray.length/2; iFlag++)
    {
        var randSequence = null;

        if (advanced_random) {
        	try {
    		  randSequence = getRandomSequence(flagsArray[2*iFlag], flagsArray[2*iFlag+1]);
    		} catch (e) {}
        }

		//use random.org with fallback to standard pseudo random generator
		if (advanced_random && randSequence.length === flagsArray[2*iFlag+1] - flagsArray[2*iFlag] + 1) {
			console.log('random with random.org');
			Array.prototype.splice.apply(permArray, [flagsArray[2*iFlag], randSequence.length].concat(randSequence));
		} else {
			console.log('fallback random');
	        for (var i = flagsArray[2*iFlag+1]; i > flagsArray[2*iFlag]; --i)
	        {
		        var randPos = flagsArray[2*iFlag] + Math.floor((i + 1 - flagsArray[2*iFlag]) * Math.random());
		        var tmpStore = permArray[i];
		        permArray[i] = permArray[randPos];
		        permArray[randPos] = tmpStore;
	        }
    	}
    }
    return permArray;
}

function secondMax(arr)
{
    var indicesMax = [];
    var max = Math.max.apply(null, arr), // get the max of the array
        // maxi = arr.indexOf(max);
    idxMax = arr.indexOf(max);
    while (idxMax != -1) {
      indicesMax.push(idxMax);
      idxMax = arr.indexOf(max, idxMax + 1);
      }
    // arr[maxi] = -Infinity; // replace max in the array with -infinity
    for(var i=0;i<indicesMax.length;i++)
    {
      arr[indicesMax[i]] = -Infinity;
    }
    var secondMax = Math.max.apply(null, arr); // get the new max
    // arr[maxi] = max;
    for(var i=0;i<indicesMax.length;i++)
    {
      arr[indicesMax[i]] = max;
    }
    return secondMax;
};

function getRandomArbitrary(min, max) {
    return Math.random() * (max - min) + min;
}

function getRandomInteger(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

function getRandomArrayValue(arr) {
  var randomIndex = getRandomInteger(0, arr.length - 1);
  return arr[randomIndex];
}

function getRandomArrayIndex(arrayLength) {
  return Math.trunc(Math.random() * arrayLength);
}

function computeRandomSelection(option){
    //check if option is interval type (i.e 100_200)
    var matchInterval = option.match(/^(\-?\d+)_(\-?\d+)$/);
    if (matchInterval) {
        var min = parseInt(matchInterval[1]);
        var max = parseInt(matchInterval[2]);
        var result = getRandomInteger(min, max);
        return result;
    }

    //handle simple alternatives like 100|200|300
    var options = [];
    if ((options = option.split('|')) && options.length > 1) {

      var randomPosition = getRandomInteger(0, options.length - 1);
      var result = options[randomPosition];
      return parseInt(result);
    }

    return parseInt(option)
}

function getAllIndexes(arr, val) {
    var indexes = [], i;
    for(i = 0; i < arr.length; i++)
        if (arr[i] === val)
            indexes.push(i);
    return indexes;
}

 function resizeIframe(obj) {
    obj.style.height = obj.contentWindow.document.body.scrollHeight + 'px';
  }

function autoResize(id){
    var newheight;
    var newwidth;

    if(document.getElementById){
        newheight=document.getElementById(id).contentWindow.document.body.scrollHeight;
        newwidth=document.getElementById(id).contentWindow.document.body.scrollWidth;
    }

    document.getElementById(id).height=(newheight) + "px";
    document.getElementById(id).width=(newwidth) + "px";
}

function getDocHeight(doc) {
    doc = doc || document;
    // stackoverflow.com/questions/1145850/
    var body = doc.body, html = doc.documentElement;
    var height = Math.max( body.scrollHeight, body.offsetHeight,
        html.clientHeight, html.scrollHeight, html.offsetHeight );
    return height;
}

function setIframeHeight(id) {
    var ifrm = document.getElementById(id);
    var doc = ifrm.contentDocument? ifrm.contentDocument:
        ifrm.contentWindow.document;
    ifrm.style.visibility = 'hidden';
    ifrm.style.height = "10px"; // reset to minimal height ...
    // IE opt. for bing/msn needs a bit added or scrollbar appears
    ifrm.style.height = getDocHeight( doc ) + 4 + "px";
    ifrm.style.visibility = 'visible';
}

function columnIsDefined(columnName){
    return definedColumns[allColumns.indexOf(columnName)] === 1;
}

function sortResponseCodes(responseCode){
    if(typeof(responseCode) == "number"){
      responseCode = responseCode.toString(10);
    }
    var codes = responseCode.split(';');
    codes = codes.sort();
    return codes.join(';');
}

//prepare a field before inserting it into a csv
//source: https://github.com/uselesscode/ucsv/blob/master/source/core.js#L36
function prepField(field){
    var rxIsInt = /^\d+$/,
    rxIsFloat = /^\d*\.\d+$|^\d+\.\d*$/,
    // If a string has leading or trailing space,
    // contains a comma double quote or a newline
    // it needs to be quoted in CSV output
    rxNeedsQuoting = /^\s|\s$|,|"|\n/,

    isNumber = function (o) {
        return Object.prototype.toString.apply(o) === '[object Number]';
    },

    isString = function (o) {
        return Object.prototype.toString.apply(o) === '[object String]';
    }

    if (isString(field)) {
      // Escape any " with double " ("")
      field = field.replace(/"/g, '""');

      // If the field starts or ends with whitespace, contains " or , or a newline or
      // is a string representing a number, quote it.
      if (rxNeedsQuoting.test(field) || rxIsInt.test(field) || rxIsFloat.test(field)) {
        field = '"' + field + '"';
      // quote empty strings
      } else if (field === "") {
        field = '""';
      }
    } else if (isNumber(field)) {
      field = field.toString(10);
    } else if (field === null || field === undefined) {
      field = '';
    } else {
      field = field.toString();
    }

    field = field.trim();
    field = field.replace(/\n/g, "\\n");
    return field;
}

function convertServerContentToCsv(saveInfoColumns, saveInfo, experimentData){
    for(var i=0; i < saveInfo.length; i++){
        saveInfo[i] = prepField(saveInfo[i]);
      }

      var csvContentServer = saveInfoColumns + "\n" + saveInfo +  "\n"+"\n";
      experimentData.forEach(function(infoArray, index){
        for(var x=0; x < infoArray.length; x++)
        {
          infoArray[x] = prepField(infoArray[x]);
        }
        dataString = infoArray.join(",");
        csvContentServer += index < experimentData.length ? dataString + "\n" : dataString;
    });

    return csvContentServer;
}

function pushRowNo(rowNo, value){
  if (!pushRowNo.rowNoOccurences) {
    // need it as object so we can store string values as keys for lists 
    pushRowNo.rowNoOccurences = {};
  }

  var rowNoToPush = getUniqueRowNo(pushRowNo.rowNoOccurences, value);
  rowNo.push(rowNoToPush);
  if(!pushRowNo.rowNoOccurences[value]){
    pushRowNo.rowNoOccurences[value] = 0;
  }
  pushRowNo.rowNoOccurences[value]++;
}


function getUniqueRowNo(rowNoOccurences, value){
  var occurences = rowNoOccurences[value];
  if(occurences){
    return value + '_' + (occurences + 1);
  }
  return value;
}

function precomputeIsFramesTrial(trialRow){
  var columnsToBeTested = ['presTime', 'ISI', 'responseWindow', 'ITI'];
  var framesRegex = /\d+f/g;

  for(var i = 0; i < columnsToBeTested.length; i++){
    var currentValue = columnForTrial(columnsToBeTested[i], trialRow);
    var matches = framesRegex.exec(currentValue);
    if(matches){
      return 1;
    }
  }
  return 0;
}

function averageValue(values, decimalPlace){
  if(decimalPlace === undefined){
    decimalPlace = 2;
  }
  var nanValues = 0;
  var sum = 0, avg;
  for(var i = 0; i < values.length; i++){
    currentValue = parseInt(values[i]);
    if(!isNaN(currentValue)){
      sum += currentValue;
    }
    else{
      nanValues++;
    }
  }
  if(isNaN(sum) || values.length == nanValues){
    avg = NaN;
  }
  else{
    avg = sum / (values.length - nanValues);
    avg = avg.toFixed(decimalPlace);
  }
  return avg;
}

function countValues(values, countTruthy) {
  let sum = 0;
  for (let i = 0; i < values.length; i++) {
      let currentValue = parseInt(values[i]);
      if (!countTruthy && !isNaN(currentValue) && currentValue === 1) {
          sum++;
      }
      else if (countTruthy && values[i] != "na") {
        sum ++;
      }
  }

  return sum;
}

function reupload(){
  $('#content').html('');
  download();
}

function getCorrectValue(response, rt) {
  if (isNaN(rt)) {
    rt = "na";
  }

  const keyValue = window.columnForTrial('key', window.trialRow);

  if(window.isSortTrial(window.trialRow) && keyValue != "na"){
    return window.getSortableScore();
  } else if(typeof window.keyTrialsLogicFn[window.trialRow] === 'function' &&
    window.keyTrialsLogicFn[window.trialRow](response, '', rt) == true && keyValue != "na") {
    return "1";
  } else if(window.isStimKey(keyValue) && keyValue != "na") {
    const correctValue = response == window.correctStim ? '1' : '0';
    return correctValue;
  } else if(response != columnForTrial('key', window.trialRow).toLowerCase() && keyValue != "na"){
    return "0";
  }
  else{
    return "na";
  }

}

function saveAllTrialResponse(response, rt){
  if(isNaN(rt)){
    rt = "na";
  }

  if(!feedbackScreen){
    window.allResponses.push(response);
    window.rowResponses[window.trialRow] = response;

    window.allRTs.push(rt);
    window.rowRTs[window.trialRow] = rt;

    const correctValue = getCorrectValue(response, rt);

    window.allCorrects.push(correctValue);
    window.rowCorrects[window.trialRow] = correctValue;
  }
}

function saveLearnTrial(){
  window.allResponses.push("na");
  window.rowResponses[window.trialRow] = "na";

  window.allRTs.push("na");
  window.rowRTs[window.trialRow] = "na";
  
  window.allCorrects.push("na");
  window.cleanTemporaryTimingVars();
}

function fitTextToElementsGroup(elements) {
  const arrElements = elements.map ? elements : Array.apply(null, elements);
  const fontSizes = arrElements.map(computeMaxFontSize);
  const minFontSize = Math.min.apply(Math, fontSizes);
  applyFontSizePx(elements, minFontSize);

  function applyFontSizePx(elements, fontSize) {
    elements.forEach(function(el) {
      el.style.fontSize = fontSize + 'px';
    });
  }

  // assumes that the content of the el is text only (no other sub elements)
  // assumes font size is expressed in px
  function computeMaxFontSize(el, options) {

    if(options === undefined){
      options = {};
    }
    // options
    const minFontSize = options.minFontSize || 10;
    const step = options.step || 3;
    const computedStyle = window.getComputedStyle(el);
    const horizontalPadding = parseInt(computedStyle.getPropertyValue('padding-left'), 10) + parseInt(computedStyle.getPropertyValue('padding-right'), 10);
    const widthToFitText = el.clientWidth - horizontalPadding;
    const initialFontSize = parseInt(computedStyle.getPropertyValue('font-size'), 10);

    const shouldDownSize = function(){
      if(el.children[0].clientWidth > widthToFitText){
        return true;
      }
      return false;
    } 
    
    // append a span so we can properly get size of the text (inline block is required for the element to have a box)
    el.innerHTML = '<span style="display:inline-block;padding:0;margin:0;border:0;outline:0">' + el.textContent + '</span>';

    if (!shouldDownSize()) {
       return initialFontSize;
    }

    var fontSize = initialFontSize;

    // decrease the font size until it fits or min font size reached
    while (shouldDownSize() && fontSize > minFontSize) {
      fontSize = fontSize - step;
      el.style.fontSize = fontSize + 'px';
    }

    // restore the content of the element
    el.innerHTML = el.textContent;
    el.style.fontSize = initialFontSize + 'px';

    return fontSize;
  }
}

// fit text of the text to fit the element
// optimized for one element only
function fitTextToElement(el, options) {
    // options
    if(options === undefined){
      options = {};
    }

    const minFontSize = options.minFontSize || 10;
    const step = options.step || 1;
    const computedStyle = window.getComputedStyle(el);
    const horizontalPadding = parseInt(computedStyle.getPropertyValue('padding-left'), 10) + parseInt(computedStyle.getPropertyValue('padding-right'), 10);
    const widthToFitText = el.clientWidth - horizontalPadding;
    const initialFontSize = parseInt(computedStyle.getPropertyValue('font-size'), 10);

    const shouldDownSize = function(){
      if(el.children[0].clientWidth > widthToFitText){
        return true;
      }
      return false;
    }

    // append a span so we can properly get size of the text (inline block is required for the element to have a box)
    el.innerHTML = '<span style="display:inline-block;padding:0;margin:0;border:0;outline:0">' + el.innerText + '</span>';

    if (!shouldDownSize()) {
       return initialFontSize;
    }

    var fontSize = initialFontSize;

    // decrease the font size until it fits or min font size reached
    while (shouldDownSize() && fontSize > minFontSize) {
      fontSize = fontSize - step;
      el.style.fontSize = fontSize + 'px';
    }

    // restore the content of the element
    el.innerHTML = el.innerText;
}

function median(values){
  values.sort(compare);
  var mid = Math.floor(values.length / 2);
  if(values.length % 2 == 0){
    return (values[mid - 1] + values[mid])/2;
  }
  else{
    return values[mid];
  }
}

function compare(a, b) {
  if(a < b){
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
}

function recordISI(info) {
  var actualISI = Math.round(info.time);
  if(window.currentScreenIndex>0 && actualISI){
    realISI_temp.push(actualISI);
    window.tempISIMeans.push(info.fps);
    window.tempISIFrames.push(info.frames);
  }
}

function recordITI(info){
  trialType = columnForTrial('type', trialRow);
  if(trialType === 'learn' || trialType === 'practice') {
    return;
  }


  realITI_temp = Math.round(info.time);
  window.ITI_f.push(info.frames);
  window.ITI_fDuration.push(info.fps);
}

function recordPresTime(info) {
  window.presTime_actual_temp.push(Math.round(info.time));
  window.tempPresTimeMeans.push(info.fps);
  window.tempPresTimeFrames.push(info.frames);
}

function recordIntrerruptedPresTime() {
  const completedPresTimes = window.presTime_actual_temp.length;
  const currentTimings = window.listTrialScreensTimings[trialRow];
  const totalPresTimes = currentTimings.length;
  if (totalPresTimes === completedPresTimes) {
    return;
  }

  const info = postponeTimingsForIndex(window.lastPresPostponeIndex);
  if (info !== null) {
    window.presTime_actual_temp.push(Math.round(info.time));
    window.tempPresTimeMeans.push(info.fps);
    window.tempPresTimeFrames.push(info.frames);
  }
}

function cleanTemporaryTimingVars(){
    window.tempPresTimeMeans = [];
    window.tempPresTimeDeviations = [];
    window.tempPresTimeLast = [];
    window.tempPresTimeFrames = [];

    window.tempISIMeans = [];
    window.tempISIDeviations = [];
    window.tempISILast = [];
    window.tempISIFrames = [];

    window.tempITIMeans = [];
    window.tempITIDeviations = [];
    window.tempITILast = [];
}

function replaceDoubleQuotesWithSingleQuotesInHTMLTags(text){
  var insideTag = false;
  splitText = text.split('');
  for(var i = 0; i < splitText.length; i++){
    if(splitText[i] == '<') {
      insideTag = true;
    }

    if(splitText[i] == '>') {
      insideTag = false;
    }

    if(splitText[i] == '\"' && insideTag){
      splitText[i] = "'";
    }
  }

  return splitText.join('');
}

function isClickTrial() {
  var isButtons = trialHasButtonsActive(window.trialRow);
  var isKeyboard = columnForTrial('keyboard', window.trialRow) != 'na';
  var responseType = columnForTrial('responseType', window.trialRow);
  var isCustomType = responseType != 'na' && responseType != "clicks";

  return !isButtons && !isKeyboard && !isCustomType;
}

//parse time in format XmYs or Xs and returns the total number of seconds as an int
function parseTime(timeString) {
  var breakRegex = /(\d+)([m|s])(\d+s)?/gm;
  if (timeString === "na" || timeString.trim().length === 0) {
    return;
  }

  if (timeString == parseInt(timeString, 10)) {
    timeString = (timeString / 1000) + 's'
  }

  var totalInSeconds = 0;

  var matches = breakRegex.exec(timeString);
  if(matches){
      var minutes, seconds;
      //minutes and seconds
      if(matches[3] != undefined){
          minutes = parseInt(matches[1], 10);
          seconds = parseInt(matches[3], 10);
          totalInSeconds = minutes * 60 + seconds;
      } 
      //minutes or seconds
      else if(matches[2] != undefined){
          if(matches[2] == 'm'){
              minutes = parseInt(matches[1], 10);
              totalInSeconds = minutes * 60;
          }
          else{
              seconds = parseInt(matches[1], 10);
              totalInSeconds = seconds;
          }
      }
  }
  return totalInSeconds;
}

function hidePreviousTrialElements() {
  window.document.body.style="";
  window.changeDesignDefault();
  document.getElementById('divQuestionForm2').style.display = 'none';
  document.getElementById('divQuestionForm').innerHTML = '';
  document.getElementById('responseContainer').innerHTML = '';
  document.getElementById('responseLabelContainer').innerHTML = '';
  $('#responseLabelContainer').hide();
  $('.responseLabel').remove();
  window.clearSortable();
  window.hideAndClearResponseBoxes();
  window.cleanHtmlTrial();
}

function isEmptyObject(obj) {
    for(let key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

// https://stackoverflow.com/a/12900504/5427388
function getFilenameExtension(filename) {
    return filename.slice((Math.max(0, filename.lastIndexOf(".")) || Infinity) + 1);
}


// returns the stim, including the extension if any
function getStimForTrialRow(trialRow, stimIndex) {

    if ( isTrialFromList(trialRow) ) {
        
        return getStimFromListsForTrialByIndex(trialRow, stimIndex);
    }

    const extension =  isTrialMediaType(trialRow) ? columnForTrial('stimFormat', trialRow) : '';
    let basename = '';

    // stimList column
    if ( hasValue(columnForTrial('stimList', trialRow)) || hasValue(columnForTrial('stim', trialRow)) ) {
        basename = removeExtension(window.stimListValues[trialRow][stimIndex], extension);

        return basename + extension;
    }

    const columnName = 'stim' + (stimIndex + 1);
    // value from dynamic lists
    if (window.trialActualValues && typeof window.trialActualValues[columnName] != 'undefined') {
        basename = window.trialActualValues[columnName];
    } else {
        basename = columnForTrial(columnName, trialRow);
    }

    if(basename === "na") {
      return "na";
    }
    return basename + extension;
}

function hasValue(value) {

    return value && value !== 'na';
}

function removeExtension(filename, extension) {
    if (extension && filename.endsWith(extension)) {
        return filename.slice(0, -extension.length);
    }

    return filename;
}


// first try to get from stim and then try to get from stim1
function firstStimColumnValue(trialRow) {
    const value = window.columnForTrial('stim', trialRow);
    if (hasValue(value)) {
        return value;
    }

    return window.columnForTrial('stim1', trialRow);
}

// add current url query parameters to url
function addCurrentQueryParamsToUrl(url) {
    const query = getQueryParams();
    return addQueryParams(url, query);

    // get query parameters string from current url
    function getQueryParams() {
        const url = window.location.search;
        const query = url.substring(url.indexOf('?') + 1);
        return query;
    }

    // append query parameters to url
    function addQueryParams(url, params) {
        if (!params) {
            return url;
        }

        const separator = url.indexOf('?') !== -1 ? '&' : '?';
        return url + separator + params;
    }
}


function generateDynamicImage(text) {
  let img = {};
  img.text = text;

  let currentStimName = replaceVariables(text, undefined, undefined, undefined, 1)

  img.src = window.locationStim + currentStimName  + '?ts=' + startPreloadTime;

  return img;
}